import React from "react";
import hairSahakarnagar from "./../../../../Images/SahakarNagar/Hair.png";
import { Helmet } from "react-helmet";
import InnerNavi from "../../../InnerServicePage/InnerNavi/InnerNavi";
import HairBotoxInSahakarNagarHead from "./HairBotoxInSahakarNagarHead";
import Members from "../../../HomePage/Members/Members";
import OurSalon from "../../../HomePage/OurSalon/OurSalon";
import Partners from "../../../HomePage/Partners/Partners";
import InstaFeed from "../../../HomePage/InstaFeed/InstaFeed";
import HelpNearYou from "../../../Help/HelpNearYou";
import TextLocReviews from "../../../TextLocReviews/TextLocReviews";
import ServiceWhy from "../../../MainServicePages/ServiceWhy/ServiceWhy";
import HairBotoxInSahakarNagarWhyChoose from "./HairBotoxInSahakarNagarWhyChoose";
import HairBotoxInSahakarNagarHow from "./HairBotoxInSahakarNagarHow";
import HairBotoxInSahakarNagarWho from "./HairBotoxInSahakarNagarWho";
import HairBotoxInSahakarNagarVerses from "./HairBotoxInSahakarNagarVerses";
import HairBotoxInSahakarNagarMaintain from "./HairBotoxInSahakarNagarMaintain";
import HairBotoxInSahakarNagarBook from "./HairBotoxInSahakarNagarBook";
import HairBotoxInSahakarNagarWhy from "./HairBotoxInSahakarNagarWhy";
import HairSalonInLavelleImg from "../../Lavelle/HairSalonInLavelle/HairSalonInLavelleImg/HairSalonInLavelleImg";

const HairBotoxInSahakarNagar = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Hair Botox Treatment in Sahakara Nagar | Hair Treatment Salon near
          Sahakara Nagar{" "}
        </title>
        <meta
          name="description"
          content=" Hair Botox Treatment in Sahakara Nagar, Bangalore is the perfect solution to bring back the shine, smoothness, and strength your hair deserves."
        />
        <link
          rel="canonical"
          href="https://scentlifestyle.com/hair-botox-treatment-in-sahakara-nagar"
        />
      </Helmet>
      <HairSalonInLavelleImg img={hairSahakarnagar} alt="hairSahakarnagar" />
      <InnerNavi
        link="/hair-salon"
        service="Hair Salon"
        currService="Hair Botox in Sahakara Nagar"
      />
      <HairBotoxInSahakarNagarHead />
      <Members />
      <OurSalon />
      <Partners />
      <InstaFeed />
      <HelpNearYou />
      <TextLocReviews />
      <ServiceWhy />
      <HairBotoxInSahakarNagarWhyChoose />
      <HairBotoxInSahakarNagarHow />
      <HairBotoxInSahakarNagarWho />
      <HairBotoxInSahakarNagarVerses />
      <HairBotoxInSahakarNagarMaintain />
      <HairBotoxInSahakarNagarWhy />
      <HairBotoxInSahakarNagarBook />
    </div>
  );
};

export default HairBotoxInSahakarNagar;
